import React from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";

export default function Founders() {
  return (
    <section
      id="founders"
      className="relative mx-auto max-w-5xl px-6 py-24 lg:px-8 lg:py-28"
    >
      <motion.div
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      >
        <p className="mb-6 font-display text-[12px] font-extrabold uppercase tracking-[0.18em] text-[#38BDF8]">
          Founders
        </p>

        <div className="relative overflow-hidden rounded-3xl border border-[#1E293B] bg-[#0F1B2D] p-8 sm:p-12 lg:p-14">
          <div className="pointer-events-none absolute -right-10 -top-10 text-[#1E293B]">
            <Quote className="h-44 w-44 rotate-180" strokeWidth={1} />
          </div>

          <p className="relative font-display text-2xl font-medium leading-[1.35] tracking-[-0.02em] text-[#F8FAFC] sm:text-3xl lg:text-[34px] lg:leading-[1.3]">
            “InfraYield was founded by infrastructure industry professionals,
            leaseholders, and investors who experienced firsthand how fragmented and
            outdated infrastructure ownership markets remain today.”
          </p>

          <div className="relative mt-10 flex flex-wrap items-center gap-x-8 gap-y-4 border-t border-[#1E293B] pt-7">
            <Pillar label="Industry" value="Infrastructure Professionals" />
            <Pillar label="Owners" value="Leaseholders" />
            <Pillar label="Capital" value="Investors" />
          </div>
        </div>
      </motion.div>
    </section>
  );
}

function Pillar({ label, value }) {
  return (
    <div>
      <p className="font-body text-[11px] font-medium uppercase tracking-[0.16em] text-[#38BDF8]">
        {label}
      </p>
      <p className="mt-1 font-display text-sm font-semibold text-[#F8FAFC]">
        {value}
      </p>
    </div>
  );
}
